module.exports = __webpack_public_path__ + "img/autoCity72logo.6fd032ac.svg";